import { wait } from '../common'

const form = document.querySelector('.vp-block-form-logout')
const ajaxWait = 200
let errorMessage = ''
let dom = {}

if (form) {
    dom = {
        process: form.querySelector('.process'),
        message: form.querySelector('.message'),
    }

    dom.process.addEventListener('click', send)
}

async function send() {
    const formData = {
        nonce: form.dataset.nonce,
        action: form.dataset.action,
    }

    // start loading
    dom.process.innerHTML = dom.process.dataset.loading
    dom.process.disabled = true
    await wait(ajaxWait)

    // send
    let response
    try {
        response = await fetch(form.dataset.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(formData),
        })
    } catch (error) {
        dom.message.innerHTML = 'Network error'
        dom.process.innerHTML = dom.process.dataset.label
        dom.process.disabled = false
        return
    }

    // end loading
    dom.process.innerHTML = dom.process.dataset.label
    dom.process.disabled = false

    // http error
    if (!response.ok) {
        dom.message.innerHTML = `Error ${response.status}`
        return
    }

    // json response
    const json = await response.json()
    document.location.reload()
}
